import React, { Component } from "react";
export default class MemoryDelayedRec extends Component {
  render() {
    var {
      delayed_re_question_1_status,
      delayed_re_question_2_status,
      delayed_re_question_3_status,
      delayed_re_question_4_status,
      delayed_re_question_5_status,
      delayed_re_question_6_status,
      delayed_re_question_7_status,
      delayed_re_question_8_status,
      delayed_congniation_total_score,
    } = this.props.data;
    return (
      <div className="row border border-dark memory_delayed_recognization_section">
        <div className="col-lg-12">
          <div className="col-lg-6">
            <br />
            <span className="fs-19">Score (0-4) </span>
            <input
              type="number"
              className="ecas-input-field"
              placeholder="Score"
              name="delayed_congniation_total_score"
              value={delayed_congniation_total_score}
            />
          </div>
        </div>
      </div>
    );
  }
}
